import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { getLocalStorage } from "@/utils/localstorage";

export function mapLocalStorageUserMetaToPayload(): Record<string, unknown> {
    if (
        !window ||
        !checkFeatureFlagGate(
            featureFlags.gwp10416DisableNonOperationalAnalyticsGateUip
        )
    ) {
        return {};
    }

    try {
        const atl_first_visit = getLocalStorage("atl_first_visit", true);
        const userMeta = atl_first_visit
            ? {
                  userMeta: JSON.stringify({
                      firstVisitActivationContext: JSON.parse(atl_first_visit)
                  })
              }
            : {};

        return userMeta;
    } catch (error) {
        console.error(
            "Error mapping local storage user meta to payload",
            error
        );
        return {};
    }
}

export function mapLocalStorageTraceIdToPayload(): Record<string, string> {
    if (
        !window ||
        !checkFeatureFlagGate(featureFlags.voltronMultiTouchAnalytics)
    ) {
        return {};
    }

    try {
        const trace_id = getLocalStorage("trace_id", true);
        return trace_id && typeof trace_id === "string"
            ? {
                  "x-wac-trace-id": trace_id
              }
            : {};
    } catch (error) {
        console.error("Error mapping local storage trace id to payload", error);
        return {};
    }
}
